module.exports = __webpack_public_path__ + "static/media/kubernetes-icon.3a15213d.svg";